export class TransactionHistoryItemConnect {
    transactionViewStepErrorTitle: TransactionHistoryViewSteps; // UI param only
    transferringStepFailed: boolean;
    receivingStepFailed: boolean;
    processingStepFailed: boolean;
    isSuccessful: boolean;
    isSyncing: boolean;

    constructor(
        public transactionId: string = '',
        public sessionId: string = '',
        public status: TransactionHistoryItemStatuses = null,
        public beginTimestamp: Date = null,
        public domains: TransactionHistoryItemDomainTypes[] = <TransactionHistoryItemDomainTypes[]>[],
        public finishTimestamp: Date = null // UI param only
    ) {
    }
}

export enum TransactionHistoryViewSteps {
    TRANSFERRING= 'Transferring',
    RECEIVING = 'Receiving',
    PROCESSING = 'Processing'
}

export enum TransactionHistoryItemStatuses {
    SUCCESS = 'success',
    FAILED = 'failed',
    PROCESSING = 'processing',
    PROCESSING_PENDING = 'processing_pending'
}

export enum TransactionHistoryItemStatusCodes {
    success = 0,
    failed = 7,
    processing = 4,
    processing_pending = 'processing_pending'
}

export enum TransactionHistoryItemDomainTypes {
    IntegrationWithSSOApp = 'Integration With SSO Application',
    Application = 'Application',
    DirectoryOrganization = 'Directory Organization',
    DirectoryUser = 'Directory User',
    RosterEntity = 'Roster Entity',
    Session = 'Session',
    GSuite = 'GSuite',
    GoogleClassroom = 'GoogleClassroom',
    Coursera = 'Coursera',
    LDAP = 'LDAP',
    LTI = 'LTI',
    Qwiklabs = 'Qwiklabs',
    GuidsForApp = 'GUIDs for App'
}

export const DIRECTORY_ORGANIZATION_RELATED_DOMAINS = [
    TransactionHistoryItemDomainTypes.DirectoryOrganization,
    TransactionHistoryItemDomainTypes.DirectoryUser
];


export class ETXTransactionHistory {
    content: ETXTransactionHistoryItemContent[];
    pageable: {
        sort: ETXTransactionHistorySortItem;
        offset: number;
        pageNumber: number;
        pageSize: number;
        unpaged: boolean;
        paged: boolean;
    };
    totalElements: number;
    totalPages: number;
    last: boolean;
    number: number;
    sort: ETXTransactionHistorySortItem;
    size: number;
    numberOfElements: number;
    first: boolean;
    empty: boolean;
}

export class ETXTransactionHistoryItemContent {
    sessionId: string; // transactionId in connect
    districtGuid: string;
    tenant: string; // 'General', ...
    status: ETXTransactionHistoryStatuses;
    timepointStart: number;
    timepointFinish: number;
}

export enum ETXTransactionHistoryStatuses {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    PROCESSING_PENDING = 'PROCESSING_PENDING',
}

export class ETXTransactionHistorySortItem {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
}



export class ETXTransactionHistoryProcessingDetails {
    sessionId: string; // transactionId in connect
    districtGuid: string;
    tenant: string; // 'General', ...
    status: ETXTransactionHistoryStatuses;
    timepointStart: number;
    timepointFinish: number;
    errors?: ETXHistoryTransactionError[];
    stages?: ETXHistoryTransactionStage[];
}

export class ETXHistoryTransactionError {
    message: string;
    partitionId: string;
    stage: ETXHistoryTransactionStageTitles;
    timepoint: number;
    date: Date; // UI param only
}

export class ETXHistoryTransactionStage {
    eventName: ETXHistoryTransactionStageTitles;
    timepoint: number;
    workerId: string;
    processingErrors: ETXHistoryTransactionError[];
    date: Date; // UI param only

    isOpened: boolean;
}

export enum ETXHistoryTransactionStageTitles {
    TRANSIENT_FINISH = 'TRANSIENT FINISH',
    ENTITY_APPLICATION = 'ENTITY APPLICATION',
    ENTITY_DISTRICT = 'ENTITY DISTRICT',
    ENTITY_SCHOOL = 'ENTITY SCHOOL',
    ENTITY_ADMIN = 'ENTITY ADMIN',
    ENTITY_STUDENT = 'ENTITY STUDENT',
    ENTITY_STAFF = 'ENTITY STAFF',
    ENTITY_CONTACT = 'ENTITY CONTACT',
    ENTITY_GROUP = 'ENTITY GROUP',
    ENTITY_SECTION = 'ENTITY SECTION',
    ENTITY_CALENDAR = 'ENTITY CALENDAR',
    ENTITY_APP_CRED = 'ENTITY APP CRED',
    ENTITY_CALENDAR_DEL = 'ENTITY CALENDAR DEL',
    ENTITY_SECTION_DEL = 'ENTITY SECTION DEL',
    ENTITY_GROUP_DEL = 'ENTITY GROUP DEL',
    ENTITY_CONTACT_DEL = 'ENTITY CONTACT DEL',
    ENTITY_STAFF_DEL = 'ENTITY STAFF DEL',
    ENTITY_STUDENT_DEL = 'ENTITY STUDENT DEL',
    ENTITY_ADMIN_DEL = 'ENTITY ADMIN DEL',
    ENTITY_SCHOOL_DEL = 'ENTITY SCHOOL DEL',
    ENTITY_DISTRICT_DEL = 'ENTITY DISTRICT DEL',
    ENTITY_APPLICATION_DEL = 'ENTITY APPLICATION DEL',
    ENTITY_IDM_APPLICATION = 'ENTITY IDM APPLICATION',
    ENTITY_LTI = 'ENTITY LTI',
    ENTITY_IDP_GSUITE = 'ENTITY IDP GSUITE',
    ENTITY_INTEGRATION = 'ENTITY INTEGRATION',
    ENTITY_INTEGRATION_DEL = 'ENTITY INTEGRATION DEL',
    ENTITY_IDP_LDAP = 'ENTITY IDP LDAP',
    ACCOMPLISHED = 'ACCOMPLISHED'
}

export const ETXHistoryTransactionStageTitlesOrder = {
    'TRANSIENT_FINISH': 0,
    'ENTITY_APPLICATION': 1,
    'ENTITY_DISTRICT': 2,
    'ENTITY_SCHOOL': 3,
    'ENTITY_ADMIN': 4,
    'ENTITY_STUDENT': 5,
    'ENTITY_STAFF': 6,
    'ENTITY_CONTACT': 7,
    'ENTITY_GROUP': 8,
    'ENTITY_SECTION': 9,
    'ENTITY_CALENDAR': 10,
    'ENTITY_APP_CRED': 11,
    'ENTITY_CALENDAR_DEL': 12,
    'ENTITY_SECTION_DEL': 13,
    'ENTITY_GROUP_DEL': 14,
    'ENTITY_CONTACT_DEL': 15,
    'ENTITY_STAFF_DEL': 16,
    'ENTITY_STUDENT_DEL': 17,
    'ENTITY_ADMIN_DEL': 18,
    'ENTITY_SCHOOL_DEL': 19,
    'ENTITY_DISTRICT_DEL': 20,
    'ENTITY_APPLICATION_DEL': 21,
    'ENTITY_IDM_APPLICATION': 22,
    'ENTITY_LTI': 23,
    'ENTITY_IDP_GSUITE': 24,
    'ENTITY_INTEGRATION': 25,
    'ENTITY_INTEGRATION_DEL': 26,
    'ENTITY_IDP_LDAP': 27,
    'ACCOMPLISHED': 28
};


export class ETXTransactionHistoryReceivingDetails {
    sessionId: string; // transactionId in connect
    startAt: number;
    finishAt: number;
    startDate: Date; // UI param only
    finishDate: Date; // UI param only
    stat: {
        districtGuid: string;
        tenant: string; // 'General', ...
        typesNumbers: {
            // 'Roster': 398,
            // 'district': 1,
            // 'admin': 1
        },
        totalMsgNumber: number; // 400
        messagesTypes: string[]; // UI param only (Roster, district, admin)
    };
}


export class ETXProcessingRelaunchResponse {
    errorMessage: string;
    taskId: string;
    cleanedProcessingData: boolean;
    scheduledTask: boolean;
}
